module.exports = __webpack_public_path__ + "static/web_JS6-e75e6af5809780c5c71807e7412cf588.jpg";